<template>
  <v-text-field
    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    :type="show ? 'text' : 'password'"
    v-bind="{ ...$attrs, ...$props }"
    @click:append="show = !show"
    v-on="$listeners"
    ref="password"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "PasswordField",
  inheritAttrs: false,
  data: () => ({
    show: false,
  }),
  methods: {
    focus() {
      this.$refs.password.focus()
    },
  },
};
</script>
